export default __webpack_public_path__ + "static/media/mercy-damageboost.caa15b51.mp3";